import { connect } from 'react-redux';
import { getGates } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
const mapStateToProps = state => {
  return {
    gates: getGates(getLatestWidgetData(state))
  };
};
const mapDispatchToProps = {};
export const withGates = connect(mapStateToProps, mapDispatchToProps);